export var ButtonCategory = /*#__PURE__*/ function(ButtonCategory) {
    ButtonCategory["default"] = "default";
    ButtonCategory["danger"] = "danger";
    return ButtonCategory;
}({});
export var ButtonState = /*#__PURE__*/ function(ButtonState) {
    ButtonState["hover"] = "hover";
    ButtonState["focused"] = "focused";
    ButtonState["disabled"] = "disabled";
    return ButtonState;
}({});
export var ButtonVariants = /*#__PURE__*/ function(ButtonVariants) {
    ButtonVariants["primary"] = "primary";
    ButtonVariants["secondary"] = "secondary";
    ButtonVariants["secondaryGrey"] = "secondaryGrey";
    ButtonVariants["tertiary"] = "tertiary";
    ButtonVariants["tertiaryGrey"] = "tertiaryGrey";
    ButtonVariants["link"] = "link";
    ButtonVariants["linkGrey"] = "linkGrey";
    ButtonVariants["plain"] = "plain";
    return ButtonVariants;
}({});
export var IconPlacement = /*#__PURE__*/ function(IconPlacement) {
    IconPlacement["left"] = "left";
    IconPlacement["right"] = "right";
    return IconPlacement;
}({});
export var ButtonSize = /*#__PURE__*/ function(ButtonSize) {
    ButtonSize["xs"] = "xs";
    ButtonSize["s"] = "s";
    ButtonSize["m"] = "m";
    ButtonSize["l"] = "l";
    ButtonSize["xl"] = "xl";
    return ButtonSize;
}({});
export var ButtonShape = /*#__PURE__*/ function(ButtonShape) {
    ButtonShape["default"] = "default";
    ButtonShape["circle"] = "circle";
    return ButtonShape;
}({});
export var ButtonAs = /*#__PURE__*/ function(ButtonAs) {
    ButtonAs["button"] = "button";
    ButtonAs["link"] = "link";
    ButtonAs["anchor"] = "anchor";
    return ButtonAs;
}({});
